
import React from "react";
import '../styling/Loader.css'

function Loader(){

    return(
        <div className="loader-layout">
            <span className="loader"></span>
        </div>
    )
}

export default Loader;